import { useAuth0 } from "@auth0/auth0-react";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import HistoryIcon from '@mui/icons-material/History';
import LogoutIcon from '@mui/icons-material/Logout';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsIcon from "@mui/icons-material/Settings";
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import Switch from '@mui/material/Switch';
import MoodIcon from '@mui/icons-material/Mood';
import PromptsIcon from '@mui/icons-material/FileCopy';
import BusinessIcon from '@mui/icons-material/Business';
import ChatIcon from '@mui/icons-material/Chat';
import TopicIcon from '@mui/icons-material/Topic';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, InputLabel, Link, ListItemButton, ListSubheader, Popover, Select, Stack, TextField, ToggleButton, Drawer, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import AppConfig from '../../../appConfig';
import { refreshSnapshot } from '../../../store/slices/company';
import { logSelector, setAPIKey } from '../../../store/slices/logs';
import LogDrawer from '../common/reviewComponents/logDrawer';
import SettingsModel from '../modals/settingsModel';
import DatePopper from './datePopper';
import SourceFilter from './sourceFilter';
import { color } from "d3";
import { convertArrayToDictionary } from "../../../common/utils";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import LocationSelector from "./locationSelector";
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import { useTheme } from '@mui/material/styles';

export default function Index({ userRoles, setConnectionState, setSelectedCompany, selectedCompany, setEnv, env, companies, pathname, setSelectedLocation, selectedLocation, locations, startDate, endDate, setEndDate, setStartDate, range, setRange }) {

  // Function to get page title based on current pathname
  const getPageTitle = (pathname) => {
    const pageMap = {
      '/responses': 'Responses',
      '/sentiments': 'Sentiments', 
      '/gbp': 'GBP',
      '/chats': 'Chats',
      '/topics': 'Topics',
      '/facts': 'Facts',
      '/pipelines': 'Pipelines',
      '/cubes': 'Cubes',
      '/rolePermissions': 'Role Permissions',
      '/prompts': 'Prompts',
      '/reviews': 'Reviews',
      '/home': 'Home'
    };
    return pageMap[pathname] || 'Dashboard';
  };
  const [filterToggle, setFilterToggle] = React.useState(false)
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElMoreMenu, setAnchorElMoreMenu] = React.useState(null);
  const [anchorElSettings, setAnchorElSettings] = React.useState(null);
  
  // Simple theme management
  const [isDarkMode, setIsDarkMode] = React.useState(() => {
    try {
      const saved = localStorage.getItem('themeMode');
      return saved === 'dark';
    } catch (error) {
      return false;
    }
  });
  
  const handleThemeToggle = () => {
    try {
      const newMode = !isDarkMode;
      setIsDarkMode(newMode);
      localStorage.setItem('themeMode', newMode ? 'dark' : 'light');
      // Force page reload to apply theme changes
      window.location.reload();
    } catch (error) {
      console.error('Theme toggle error:', error);
    }
  };
  
  const theme = useTheme();
  const [showAllLogs, setShowAllLogs] = React.useState(false)
  const [showRefreshDialog, setShowRefreshDialog] = React.useState(false);
  const [openDevModal, setOpenDevModal] = React.useState(null);
  const isIRUser = React.useMemo(() => userRoles?.indexOf("IRUser") >= 0, [userRoles]);
  const isRRUser = React.useMemo(() => userRoles?.indexOf("RRUser") >= 0, [userRoles]);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openSettings, setOpenSettings] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [companyAnchorEl, setCompanyAnchorEl] = React.useState(null);
  const { input } = useSelector(logSelector)

  const [openMoreButton, setMoreButtonToggle] = React.useState(false)
  const [anchorElMore, setAnchorElMore] = React.useState(null);
  const[toggleIsActive, setToggleleIsActive] = useState(false);
  const toggleURL = ['#/topics', '#/pipelines', '#/ranking', '#/cubes', '#/chats', '#/gbp', '#/facts'];
  const [searchTerm, setSearchTerm] = useState('');

  const compDic = React.useMemo(()=>convertArrayToDictionary(companies,'companyId'),[companies]);
  const handleMoreClick = (event) => {
    setAnchorElMore(event.currentTarget);
    setMoreButtonToggle(true);
  };

  const handleMoreClose = () => {
    setAnchorElMore(null);
    setMoreButtonToggle(false);
    setToggleleIsActive(true);
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
    setFilterToggle(true)
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterToggle(false)
  };
  const { apiKey } = useSelector(logSelector);
  const toggleDrawer = (isOpen) => {
    setOpenDrawer(isOpen);
  };
  const toggleSettings = (isOpen) => {
    setOpenSettings(isOpen);
  };
  const onSetAPIKey = (key) => {
    dispatch(setAPIKey(key));
  };

  const { logout, isAuthenticated, user } = useAuth0();
  const dispatch = useDispatch()
  const handleCompanyChange = (event) => {
    const companyId = event.target.value;
    setSelectedCompany(companyId);
    setSelectedLocation('all')
    handleCloseUserMenu();
    const tabId = sessionStorage.getItem('env')
    let localCompanyIds = JSON.parse(localStorage.getItem('company')) ?? {}
    localCompanyIds[tabId] = companyId
    localStorage.setItem('company', JSON.stringify(localCompanyIds))
    window.location.reload();

  };
  const handleEnv = (event) => {
    const env = event.target.value;

    sessionStorage.setItem('env', env)
    // setEnv(env)

    window.location.reload();
    // setConnectionState(false)
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenMoreMenu = (event) => {
    setAnchorElMoreMenu(event.currentTarget);
  };

  const handleCloseMoreMenu = () => {
    setAnchorElMoreMenu(null);
  };

  const handleOpenSettingsMenu = (event) => {
    setAnchorElSettings(event.currentTarget);
  };

  const handleCloseSettingsMenu = () => {
    setAnchorElSettings(null);
  };

  const handleDevelopmentMenuOpen = () => {
    setOpenDevModal(true);
  }
  const handleStartDateChange = (value) => {
    setStartDate(moment(value).format("YYYY-MM-DD"));
    if (value && endDate) {
    }
  };

  const handleEndDateChange = (value) => {
    setEndDate(moment(value).format("YYYY-MM-DD"));
    if (startDate && value) {
    }
  };
  const handleLocationChange = (event) => {
    const locationId = event.target.value;
    const selectedLocation = locations.find(
      (location) => location.locationId === locationId
    );
    setSelectedLocation(locationId);
    handleCloseUserMenu();
  };
  const rfreshSnapshot = () => {
    dispatch(refreshSnapshot(selectedCompany))
    handleCloseUserMenu();
  }

  const handleRefreshDialogOpen = () => {
    setShowRefreshDialog(true);
  };

  const handleRefreshDialogClose = () => {
    setShowRefreshDialog(false);
  };

  const handleRefreshConfirm = () => {
    rfreshSnapshot();
    handleCloseMoreMenu();
    setShowRefreshDialog(false);
  };
  const MenuItemStyle = {
    '&:hover': {
      background:'#1565c0', 
    },
    '& a': {
        textDecoration: 'none',
        color: '#fff'
    },
};

const companyList = React.useMemo(() => {
  const data = _.reduce(_.filter(companies, company => company.name.toLowerCase().includes(searchTerm.toLowerCase())&&!company?.isAgency), (result, company) => {
   
    const groupKey = company?.agencyName || 'Other Companies';
    
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    
    result[groupKey].push(company);
    
    return result;
  }, {});

  const sortedData = {};
  const sortedKeys = _.keys(data).sort((a, b) => {
    if (a === 'Other Companies') return 1;
    if (b === 'Other Companies') return -1;
    return a.localeCompare(b);
  });

  sortedKeys.forEach(key => {
    sortedData[key] = _.sortBy(data[key], company => company.name.toLowerCase());
  });

  return sortedData;
}, [companies, searchTerm]);


const checkCurrentUrl = window.location.hash;
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar 
        position="static" 
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          marginLeft: '64px',
          width: 'calc(100% - 64px)',
          // borderBottom: '1px solid #efefef',
          height: '48px',
          minHeight: '48px'
        }}
      >
        <Toolbar sx={{ minHeight: '48px !important', height: '48px' }}>
          {/* Page Title */}
          <Typography
            variant="h2"
            component="h2"
            className="page-title"
            sx={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginRight: 'auto',
              lineHeight: 1,
              color: theme.palette.text.primary
            }}
          >
            {getPageTitle(pathname)}
          </Typography>
          
          {/* Logo moved to sidebar top */}
          {/* 
          <Grid>
            <img
              src={"./images/playLogo.png"}
              alt={"Admin-logo"}
              height={"54px"}
            ></img>
          </Grid>
          <Typography
            variant="h5"
            noWrap
            component="div"
            sx={{ display: { xs: "none", sm: "block" }, paddingLeft: 2 }}
          >
            Playground
          </Typography>
          */}

          {/* Main navigation moved to sidebar */}
          {/*
          <Stack direction={"row"} spacing={3} sx={{ ml: "75px", overflowX: 'auto', overflowY: 'hidden', justifyContent:'space-between' }}>
            <NavLink to="/responses" style={{ textDecoration: "none" }}>
              {({ isActive, isPending }) => (
                <Stack
                  direction="row"
                  alignItems={"center"}
                  sx={{
                    backgroundColor: isActive ? "primary.dark" : "",
                    height: "60px",
                    px: 1,
                    borderBottom: (theme) =>
                      isActive
                        ? `4px solid ${theme.palette.primary.light}`
                        : "",
                  }}
                >
                  <Typography color="white" sx={{ textDecoration: "none" }}>
                    Responses
                  </Typography>
                </Stack>
              )}
            </NavLink>
            {
              <NavLink
                to="/sentiments"
                style={{ textDecoration: "none" }}
              >
                {({ isActive, isPending }) => (
                  <Stack
                    direction="row"
                    alignItems={"center"}
                    sx={{
                      backgroundColor: isActive ? "primary.dark" : "",
                      height: "60px",
                      px: 1,
                      borderBottom: (theme) =>
                        isActive
                          ? `4px solid ${theme.palette.primary.light}`
                          : "",
                    }}
                  >
                    <Typography color="white" sx={{ textDecoration: "none" }}>
                      Sentiments
                    </Typography>
                  </Stack>
                )}
              </NavLink>
            }
            <NavLink
              to="/prompts"
              style={{ textDecoration: "none" }}
            >
              {({ isActive, isPending }) => (
                <Stack
                  direction="row"
                  alignItems={"center"}
                  sx={{
                    backgroundColor: isActive ? "primary.dark" : "",
                    height: "60px",
                    px: 1,
                    borderBottom: (theme) =>
                      isActive
                        ? `4px solid ${theme.palette.primary.light}`
                        : "",
                  }}
                >
                  <Typography color="white" sx={{ textDecoration: "none" }}>
                    Prompts
                  </Typography>
                </Stack>
              )}
            </NavLink>
          </Stack>
          */}

          {/* More menu moved to sidebar */}
          {/*
          <div>
            <ToggleButton
              aria-label="more"
              id="long-button"
              aria-controls={openMoreButton ? 'long-menu' : undefined}
              aria-expanded={openMoreButton ? 'true' : undefined}
              aria-haspopup="true"
              selected={openMoreButton}
              onClick={(e) => {
                openMoreButton ? handleMoreClose(e) : handleMoreClick(e);
              }}
              sx={{ ml:3, border: "none", backgroundColor: toggleURL?.includes(checkCurrentUrl)? theme.palette.primary.dark : null, 
                "&:hover":{background:toggleURL?.includes(checkCurrentUrl)? '#1565c0' : null,}}}
            >
              <MoreHorizIcon sx={{ color: "#fff" }} />
            </ToggleButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorElMore}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              open={Boolean(anchorElMore)}
              onClose={handleMoreClose}
              sx={{ '& .MuiList-root':{ background: '#3681EB'}, '& .MuiButtonBase-root.MuiMenuItem-root':{p:0, display:'block'}, '& .MuiButtonBase-root.MuiMenuItem-root a':{padding:'6px 16px', display:'block'} }}
            >
               <MenuItem onClick={handleMoreClose} sx={{...MenuItemStyle, backgroundColor: pathname==='/gbp' ? theme.palette.primary.dark : null}}>
                  <NavLink to="/gbp" style={{ textDecoration: "none" }}>
                    GBP
                  </NavLink>
                </MenuItem>
               {<MenuItem onClick={handleMoreClose} sx={{...MenuItemStyle, backgroundColor: pathname==='/chats' ? theme.palette.primary.dark : null}}>
                  <NavLink to="/chats" style={{ textDecoration: "none" }}>
                    Chats
                  </NavLink>
                </MenuItem>}
              <MenuItem onClick={handleMoreClose} sx={{...MenuItemStyle, backgroundColor: pathname==='/topics' ? theme.palette.primary.dark : null}} >
                <NavLink to="/topics" style={{ textDecoration: "none" }}>
                  Topics
                </NavLink>
              </MenuItem>
              <MenuItem onClick={handleMoreClose} sx={{...MenuItemStyle, backgroundColor: pathname==='/facts' ? theme.palette.primary.dark : null}} >
                <NavLink to="/facts" style={{ textDecoration: "none" }}>
                  Facts
                </NavLink>
              </MenuItem>

              <MenuItem onClick={handleMoreClose} sx={{...MenuItemStyle, backgroundColor: pathname==='/pipelines' ? theme.palette.primary.dark : null}}>
                <NavLink to="/pipelines" style={{ textDecoration: "none" }}>
                  Pipelines
                </NavLink>
              </MenuItem>

              {
                <MenuItem onClick={handleMoreClose} sx={{...MenuItemStyle, backgroundColor: pathname==='/cubes' ? theme.palette.primary.dark : null}}>
                  <NavLink to="/cubes" style={{ textDecoration: "none" }}>
                    Cubes
                  </NavLink>
                </MenuItem>
              }
               {isIRUser &&<MenuItem onClick={handleMoreClose} sx={{...MenuItemStyle, backgroundColor: pathname==='/rolePermissions' ? theme.palette.primary.dark : null}}>
                  <NavLink to="/rolePermissions" style={{ textDecoration: "none", color:'#f09b00' }}>
                    Role Permissions
                  </NavLink>
                </MenuItem>}
              
            </Menu>
          </div>
          */}

          <Box sx={{flexGrow:1, ml:'50px'}}>
          <Stack direction="row" spacing={0.5} alignItems={"center"} justifyContent={'flex-end'}>
            <FormControl
              size="small"
              sx={{ 
                cursor: "pointer", 
                width: "140px", 
                pr: 1, 
              }}
              fullWidth
            >
              <Select
                sx={{ 
                  backgroundColor: theme.palette.background.paper, 
                  border: '1px solid transparent', 
                  // '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                  // '&:hover .MuiOutlinedInput-notchedOutline': {
                  //   border: '1px solid #ccc'
                  // },
                  fontSize: '14px',
                  '& .MuiSelect-select': {
                    paddingTop: '6px',
                    paddingBottom: '6px',
                    paddingLeft: '8px',
                    paddingRight: '8px'
                  }
                }}
                value={env}
                onChange={handleEnv}
                fullWidth
              >
                {/* {companies
                    ?.slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((company) => (
                      <MenuItem
                        key={company.companyId}
                        value={company.companyId}
                      >
                        {company.name}
                      </MenuItem>
                    ))} */}
                {_.map(AppConfig.envsList, env1 => {
                
                return (<MenuItem
                  key={env1.value}
                  value={env1.value}
                  sx={{ fontSize: '14px', py: 0.5 }}
                >
                  {_.startCase(env1?.label)}
                </MenuItem>)}
              )}
              </Select>
            </FormControl>
            {pathname !== "/topics" && pathname !== '/cubes' && (
              <FormControl
                size="small"
                sx={{ 
                  cursor: "pointer", 
                  width: "280px", 
                  pr: 1, 
                  // border: 'none',
                  // '&:hover .MuiButton-root': {
                  //   border: '1px solid #ccc'
                  // }
                }}
                
              >
                  {/* <Select
                    sx={{ backgroundColor: theme.palette.background.paper }}
                    value={selectedCompany ?? ""}
                    onChange={handleCompanyChange}
                    fullWidth
                    size="small"
                  >
                    <Box value="" onClick={(e)=>e.stopPropagation()}>
                    <TextField
                      size="small"
                      placeholder="Search Company"
                      onChange={(e) => {setSearchTerm(e.target.value)}}
                      value={searchTerm}
                      />
                      </Box>
                    {_.map(_.keys(companyList), (groupName) => [
                      <ListSubheader
                        key={`header-${groupName}`}
                        sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.default }}
                      >
                        {groupName}
                      </ListSubheader>,

                      _.map(companyList?.[groupName], (company) => (
                        <MenuItem
                          key={company.companyId}
                          value={company.companyId}
                          sx={{ pl: 3 }}
                        >
                          {company.name} <span className="text-muted">{company.isAgency ? "(Agency Portal)" : ""}</span>
                        </MenuItem>
                      ))
                    ])}
                  </Select> */}

                  <Button variant="contained" onClick={(e) => setCompanyAnchorEl(e.currentTarget)} sx={{textTransform:'none', minWidth:'250px', height:'32px', backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, fontWeight: 'normal', border:`1px solid ${theme.palette.mode === 'dark' ? theme.palette.secondary[200] : 'rgba(0, 0, 0, 0.23)'}`, '&:hover':{
                   justifyContent:'space-between', boxShadow: 'none',  backgroundColor: 'transparent'
                  },
                  justifyContent:'space-between', fontSize:'14px !important', paddingLeft:'8px', paddingRight:'4px', boxShadow:'none'
                  }}>
                    <span style={{maxWidth:'250px', whiteSpace:'nowrap', textOverflow:'ellipsis', overflow:'hidden', fontSize:'14px'}}>
                     {compDic?.[ selectedCompany ]?.name || ""}
                     </span> 
                     <span style={{display: 'inline-flex', alignItems: 'center'}}> {companyAnchorEl ? <ArrowDropUpIcon  sx={{color: 'white', fontSize:'24px'}}/> : <ArrowDropDownIcon sx={{color: 'white', fontSize:'24px'}} />}</span>
                  </Button>
                  <Popover

                    open={Boolean(companyAnchorEl)}
                    anchorEl={companyAnchorEl}
                    onClose={() => setCompanyAnchorEl(null)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    sx={{
                      maxHeight:'calc(100vh - 200px)',
                      marginTop:'5px'
                    }}
                  >
                    <Box p={1}>
                    <TextField
                      size="small"
                      placeholder="Search Company"
                      onChange={(e) => {setSearchTerm(e.target.value)}}
                      value={searchTerm}
                      fullWidth
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: '14px',
                          padding: '6px 8px'
                        }
                      }}
                      />
                      </Box>
                    {_.map(_.keys(companyList), (groupName) => [
                      <ListSubheader
                        key={`header-${groupName}`}
                        sx={{ fontWeight: 'bold', lineHeight: '32px', fontSize: '14px', py: 0.5, backgroundColor: theme.palette.mode === 'dark' ? '#343b44' : '#d6e5f9' }}
                      >
                        {groupName}
                      </ListSubheader>,

                      _.map(companyList?.[groupName], (company) => (
                        <MenuItem
                          key={company.companyId}
                          value={company.companyId}
                          sx={{ pl: 4, py: 0.5, fontSize: '14px', minHeight: '32px' }}
                          onClick={() =>handleCompanyChange({target:{value:company.companyId}})}
                          selected={company.companyId === selectedCompany}
                        >
                          {company.name} <span className="text-muted" style={{fontSize: '12px'}}>{company.isAgency ? "(Agency Portal)" : ""}</span>
                        </MenuItem>
                      ))
                    ])}
                  </Popover>

              </FormControl>

            )}
          
          {/* {pathname !== '/topics' && pathname !== '/cubes' && (isIRUser || isRRUser) && <DatePopper startDate={startDate} range={range} setRange={setRange} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} width={260} />
          } */}
          
          {/* <IconButton sx={{ mr: 1.5 }} onClick={() => toggleSettings(true)}>
            <SettingsOutlinedIcon sx={{ color: "#fff" }} />
          </IconButton> */}
          </Stack>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
          {/* {pathname !== '/topics' && pathname !== '/cubes' &&  (
            <ToggleButton
              selected={filterToggle}
              onClick={(e) => {
                filterToggle ? handleFilterClose(e) : handleFilterClick(e);
              }}
              sx={{ border: "none" }}
            >
              <FilterAltIcon sx={{ color: "#757575" }} />
            </ToggleButton>
          )} */}
          <IconButton sx={{ mr: 1.5, borderRadius: "6px", padding: "4px 6px" }} onClick={() => toggleDrawer(true)}>
            <HistoryIcon sx={{  }} />
          </IconButton>
            {/* Profile menu moved to sidebar */}
            {/*
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt={user?.name} src={user?.picture} />
            </IconButton>
            */}
          </Box>
        </Toolbar>
      </AppBar>
      
      {/* Profile Menu - works with sidebar profile */}
      <Menu
        sx={{ ml: "5px" }}
        id="menu-appbar"
        PaperProps={{
          style: {
            minWidth: 250,
          },
        }}
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Box sx={{ p: 2 }}>
          <Stack direction="row" spacing={1.75} alignItems="center" sx={{ mb: 2 }}>
            <Avatar alt={user?.name} src={user?.picture} />
            <Typography variant="subtitle1">
              {user?.name}
            </Typography>
          </Stack>
          
          <MenuItem onClick={() => {
            logout({
              logoutParams: { returnTo: window.location.origin },
            });
            handleCloseUserMenu();
          }} sx={{ p: 0, pl: 7 }}>
            <LogoutIcon sx={{ mr: 2 }} />
            <Typography>Logout</Typography>
          </MenuItem>
        </Box>
      </Menu>
      
      {/* More Menu - popup for additional menu items */}
      <Menu
        sx={{ ml: "-5px", mt: "80px" }}
        id="more-menu"
        PaperProps={{
          style: {
            width: 200,
          },
        }}
        anchorEl={anchorElMoreMenu}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        open={Boolean(anchorElMoreMenu)}
        onClose={handleCloseMoreMenu}
      >
        <MenuItem onClick={handleCloseMoreMenu}>
          <NavLink to="/chats" style={{ textDecoration: "none", display: 'flex', alignItems: 'center', width: '100%', color: 'inherit' }}>
            <ChatIcon sx={{ mr: 2 }} />
             
            <Typography>Chats</Typography>
          </NavLink>
        </MenuItem>
        <MenuItem onClick={handleCloseMoreMenu}>
          <NavLink to="/gbp" style={{ textDecoration: "none", display: 'flex', alignItems: 'center', width: '100%', color: 'inherit' }}>
            <BusinessIcon sx={{ mr: 2 }} />
            <Typography>GBP</Typography>
          </NavLink>
        </MenuItem>
        
        <MenuItem onClick={handleCloseMoreMenu}>
          <NavLink to="/pipelines" style={{ textDecoration: "none", display: 'flex', alignItems: 'center', width: '100%', color: 'inherit' }}>
            <AccountTreeIcon sx={{ mr: 2 }} />
            <Typography>Pipelines</Typography>
          </NavLink>
        </MenuItem>
        
        {isIRUser && (
          <MenuItem onClick={handleCloseMoreMenu}>
            <NavLink to="/rolePermissions" style={{ textDecoration: "none", display: 'flex', alignItems: 'center', width: '100%', color: '#f09b00' }}>
              <AdminPanelSettingsIcon sx={{ mr: 2, color: '#f09b00' }} />
              <Typography>Role Permissions</Typography>
            </NavLink>
          </MenuItem>
        )}
        
        <MenuItem onClick={handleCloseMoreMenu}>
          <NavLink to="/cubes" style={{ textDecoration: "none", display: 'flex', alignItems: 'center', width: '100%', color: 'inherit' }}>
            <ViewModuleIcon sx={{ mr: 2 }} />
            <Typography>Cubes</Typography>
          </NavLink>
        </MenuItem>
        
      </Menu>
      
      {/* Settings Menu */}
      <Menu
        sx={{ ml: "-5px", mt: "10px" }}
        id="settings-menu"
        PaperProps={{
          style: {
            width: 280,
          },
        }}
        anchorEl={anchorElSettings}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        open={Boolean(anchorElSettings)}
        onClose={handleCloseSettingsMenu}
      >
        <MenuItem onClick={() => { handleRefreshDialogOpen(); handleCloseSettingsMenu(); }}>
          <RefreshIcon sx={{ mr: 2 }} />
          <Typography>Refresh Snapshot</Typography>
        </MenuItem>
        
        <Divider />
        
        <MenuItem>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <WbSunnyIcon sx={{ mr: 2, color: 'white' }} />
              <Typography>Theme</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2">
                Light
              </Typography>
              <Switch
                size="small"
                checked={isDarkMode}
                onChange={handleThemeToggle}
              />
              <Typography variant="body2">
                Dark
              </Typography>
            </Box>
          </Box>
        </MenuItem>
      </Menu>
      
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          width: 64,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 64,
            boxSizing: 'border-box',
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.primary.main,
            top: 0, // Start from top of page
            height: '100%', // Full height
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            '& .MuiSvgIcon-root': {
              color: 'white !important', // All icons white with !important
            },
            '& .MuiListItemIcon-root': {
              color: 'white !important', // List item icons white with !important
            },
            '& .MuiIconButton-root': {
              color: 'white !important', // Icon buttons white with !important
            },
            '& svg': {
              color: 'white !important', // All SVG elements white with !important
            }
          },
        }}
      >
        {/* Logo at top of sidebar */}
        <Box sx={{ padding: 1, display: 'flex', justifyContent: 'center', height: '64px' }}>
          <Tooltip title="Playground" placement="right">
            <img
              src={"./images/playLogo.png"}
              alt={"Admin-logo"}
              width={"42px"}
              style={{ maxWidth: '60px', objectFit: 'contain' }}
            />
          </Tooltip>
        </Box>
        
        <List sx={{ padding: 0, flexGrow: 1 }}>
          {/* Main Navigation Items */}
          <Tooltip title="Prompts" placement="right">
            <ListItem
              component={NavLink}
              to="/prompts"
              sx={{
                padding: 0,
                '&.active': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <PromptsIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>

          <Tooltip title="Responses" placement="right">
            <ListItem
              component={NavLink}
              to="/responses"
              sx={{
                padding: 0,
                '&.active': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <QuestionAnswerIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
          
          <Tooltip title="Sentiments" placement="right">
            <ListItem
              component={NavLink}
              to="/sentiments"
              sx={{
                padding: 0,
                '&.active': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <MoodIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
          
          {/* Menu Items from More Button */}
{/*           
          <Tooltip title="Chats" placement="right">
            <ListItem
              component={NavLink}
              to="/chats"
              sx={{
                padding: 0,
                '&.active': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <ChatIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip> */}
          
          <Tooltip title="Topics" placement="right">
            <ListItem
              component={NavLink}
              to="/topics"
              sx={{
                padding: 0,
                '&.active': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <TopicIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
          
          <Tooltip title="Facts" placement="right">
            <ListItem
              component={NavLink}
              to="/facts"
              sx={{
                padding: 0,
                '&.active': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <FactCheckIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
                   
          <Tooltip title="More" placement="right">
            <ListItem
              sx={{
                padding: 0,
                backgroundColor: ['/gbp', '/pipelines', '/rolePermissions', '/cubes', '/chats'].includes(pathname) ? 'rgba(255,255,255,0.3)' : 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                onClick={handleOpenMoreMenu}
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <MoreHorizIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
        </List>
        
        {/* Settings and Profile Section at Bottom */}
        <List sx={{ padding: 0 }}>
          <Tooltip title="Settings" placement="right">
            <ListItem
              sx={{
                padding: 0,
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              <ListItemButton
                onClick={handleOpenSettingsMenu}
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <SettingsIcon sx={{ color: 'white' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
          
          <ListItem
            sx={{
              padding: 1,
              borderTop: '1px solid rgba(255,255,255,0.2)',
            }}
          >
            <Tooltip title="Profile" placement="right">
              <ListItemButton
                onClick={handleOpenUserMenu}
                sx={{
                  minHeight: 60,
                  justifyContent: 'center',
                  px: 1,
                  flexDirection: 'column',
                }}
              >
                <Avatar 
                  alt={user?.name} 
                  src={user?.picture} 
                  sx={{ width: 32, height: 32, mb: 0.5 }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: 'white',
                    fontSize: '10px',
                    textAlign: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                  }}
                >
                  {/* {user?.name?.split(' ')[0]} */}
                </Typography>
              </ListItemButton>
            </Tooltip>
          </ListItem>
        </List>
      </Drawer>
      
      {openDrawer && <LogDrawer
        openDrawer={openDrawer}
        toggleDrawer={toggleDrawer}
        showAll
        showAllLogs={showAllLogs}
        setShowAllLogs={setShowAllLogs}
        selectedCompany={selectedCompany}
      />}
      <SettingsModel
        open={openSettings}
        onClose={() => toggleSettings(false)}
        onSetAPIKey={onSetAPIKey}
        apiKey={apiKey}
      />
      {/* <Popover
        open={filterToggle}
        onClose={handleFilterClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', padding: '16px', gap: '16px' }}>


          <LocationSelector/>
          <SourceFilter />
        </div>
      </Popover> */}
      
      {/* Refresh Snapshot Confirmation Dialog */}
      <Dialog
        open={showRefreshDialog}
        onClose={handleRefreshDialogClose}
        aria-labelledby="refresh-dialog-title"
        aria-describedby="refresh-dialog-description"
      >
        <DialogTitle id="refresh-dialog-title">
          Confirm Refresh
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="refresh-dialog-description">
            Are you sure you want to Refresh Snapshot?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRefreshDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleRefreshConfirm} color="primary" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
